import { createAction, props } from '@ngrx/store';
import { ISupportRequest } from 'src/app/shared/models/stepper/ISupportRequest';
import { IResponseMessage } from 'src/app/shared/models/response-message/IResponseMessage';
export const StepperActionTypes = {
    SEND_STEPPER_FORM: '[STEPPER] send stepper form',
    SEND_STEPPER_FORM_SUCCESS: '[STEPPER] send stepper form success',
    SEND_STEPPER_FORM_FAIL: '[STEPPER] send stepper form fail',
    INIT_DEFAULT_ITEM_IDS: '[STEPPER] init default item ids',
    INIT_DEFAULT_ITEM_IDS_SUCCESS: '[STEPPER] init default item ids success',
};

export const SendStepperForm = createAction(
    StepperActionTypes.SEND_STEPPER_FORM,
    props<{ data: ISupportRequest, files?: { id: string }[]}>()
);

export const SendStepperFormSuccess = createAction(
    StepperActionTypes.SEND_STEPPER_FORM_SUCCESS,
    props<IResponseMessage>()
);

export const SendStepperFormFail = createAction(
    StepperActionTypes.SEND_STEPPER_FORM_FAIL,
    props<{ error: IResponseMessage }>()
);

export const InitDefaultItemIds = createAction(
    StepperActionTypes.INIT_DEFAULT_ITEM_IDS
);

export const InitDefaultItemIdsSuccess = createAction(
    StepperActionTypes.INIT_DEFAULT_ITEM_IDS_SUCCESS,
    props<{defaultItemIds: {[key: string]: string}}>()
);
